import type { FC } from "react";
import { Card } from "@tennr/frontend/components/Card";
import "./PartnerCard.css";

type PartnerCardProps = {
  logo: string;
  name: string;
};

export const PartnerCard: FC<PartnerCardProps> = ({ logo, name }) => (
  <Card className="partner-card">
    <img src={logo} alt={name} draggable={false} />
  </Card>
);
